/**
 * @module FAQ Item
 * @description
 */
import { useState } from 'react';
import classNames from 'classnames/bind';
import styles from './index.module.css';

const cx = classNames.bind( styles );

/**
 * @function Component
 * @description
 */
const Component = ( { id, title, children } ) => {
  const [ isExpanded, setIsExpanded ] = useState( false );

  // Conditionally set active classnames
  const iconClassName = cx( {
    'icon-chevron-down1': true,
    icon: true, // always load icon styles
    isExpanded // Load isExpanded based on bool
  } );

  const buttonClassName = cx( {
    button: true,
    h6: true,
    borderBottom: ! isExpanded
  } );

  return (
    <>
      <h3 className='h6'>
        <button
          id={ `${ id }-header` }
          aria-controls={ `${ id }-panel` }
          aria-expanded={ isExpanded }
          onClick={ () => setIsExpanded( ! isExpanded ) }
          className={ buttonClassName }
        >
          { title }
          <span className={ iconClassName } />
        </button>
      </h3>

      <section
        className={ `${ styles.borderBottom } ${ styles.item }` }
        id={ `${ id }-panel` }
        aria-labelledby={ `${ id }-header` }
        hidden={ ! isExpanded }
      >
        <p>{ children }</p>
      </section>
    </>
  );
};

export default Component;
